<template>
  <section>
    <h1 class="title">{{$t('register-new-user', 'Register new user')}}</h1>
    <div class="columns">
      <div class="column is-one-third">
        <div v-if="errors.length > 0" class="notification is-danger">
          <strong>Error</strong>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <user-form @onSubmitUser="submitNewUser" showSubmit />
        <p v-if="isSubmitting">
          <font-awesome-icon icon="circle-notch" fixed-width spin />&nbsp;{{$t('creating-user', 'Creating user...')}}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import UserForm from '@/components/UserForm'

export default {
  name: 'NewUser',
  components: { UserForm },
  data () {
    return {
      errors: [],
      isSubmitting: false
    }
  },
  methods: {
    submitNewUser ({ username, role, password, confirmPassword }) {
      this.isSubmitting = true
      this.errors = []

      api.users.create({ username, role, password, confirmPassword })
        .then((res) => {
          this.$notifySuccess(undefined, this.$t('create-user-success', 'Successfully created new user'))
        })
        .catch((e) => {
          this.errors = [e.response.data]
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
